import { Loader2 } from 'lucide-react'
import Modal from './Modal'

interface ConfirmDialogProps {
  open: boolean
  title: string
  /** Corpo da confirmação — string ou conteúdo rico */
  children: React.ReactNode
  confirmLabel?: string
  cancelLabel?: string
  /** 'danger' pinta o botão de confirmação de vermelho */
  variant?: 'default' | 'danger'
  loading?: boolean
  onConfirm: () => void
  onCancel: () => void
}

/** Substituto acessível para window.confirm() */
export default function ConfirmDialog({
  open,
  title,
  children,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  variant = 'default',
  loading = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const confirmClasses =
    variant === 'danger'
      ? 'bg-red-600 hover:bg-red-700 focus:ring-red-500'
      : 'bg-agent hover:bg-purple-700 focus:ring-agent'

  return (
    <Modal open={open} onClose={onCancel} title={title} size="sm" dismissable={!loading}>
      <div className="text-sm text-gray-600 dark:text-gray-300">{children}</div>
      <div className="mt-5 flex justify-end gap-2">
        <button
          type="button"
          onClick={onCancel}
          disabled={loading}
          className="px-4 py-2 rounded-lg text-sm font-medium text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-400 disabled:opacity-50"
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={loading}
          data-autofocus
          className={`px-4 py-2 rounded-lg text-sm font-medium text-white focus:outline-none focus:ring-2 disabled:opacity-50 inline-flex items-center gap-2 ${confirmClasses}`}
        >
          {loading && <Loader2 className="w-4 h-4 animate-spin" aria-hidden="true" />}
          {confirmLabel}
        </button>
      </div>
    </Modal>
  )
}
